module.exports = __webpack_public_path__ + "static/img/fj.5fb05af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fj.png
// module id = 5tcY
// module chunks = 1